import { render, staticRenderFns } from "./RelatoriosPesquisaSatisfacao.vue?vue&type=template&id=0c69a965&"
import script from "./RelatoriosPesquisaSatisfacao.vue?vue&type=script&lang=js&"
export * from "./RelatoriosPesquisaSatisfacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports